module.exports = __webpack_public_path__ + "f8dca1348b37de53ffb11b63cb49ba23.svg";